/**
 * Calculate the number of days between two dates
 * @param {Date} startDate - The starting date
 * @param {Date} endDate - The ending date
 * @returns {number} The number of days between the dates (positive if endDate is after startDate)
 */
export const calculateDaysBetween = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;

  if (startDate > endDate) return 0;
  // Reset time to avoid timezone issues
  const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const end = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  const timeDiff = end.getTime() - start.getTime();
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

  return daysDiff;
};
